import { useEffect } from "react";

import { toastSuccess } from "../../utils/toasts";

export const useTriggerToastOnRTKSuccess = (
  isSuccess: boolean,
  message: string
) => {
  useEffect(() => {
    if (isSuccess) {
      toastSuccess(message);
    }
  }, [isSuccess, message]);
};
